import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { MoreVertical, Star } from "react-feather";
import Dropdown from "../Dropdown/Dropdown";
import { FaRegClock } from "react-icons/fa";
import {
  dragStart,
  dragEnd,
  dragOver,
  updateCard,
} from "../../../Redux/Reducers/CrmSlice";

import "./Card.css";
import SchuduleScreen from "./SchuduleScreen";
import Modal from "../Modal/Modal";
import NewLeadForm from "../LeadForm/NewLeadForm";
import { activityFormat } from "../../../DataApi/activity_format";
import { useSession } from "../../../authentications/SessionContext";
import ScheduleActivitiesList from "./ScheduleActivitiesList";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import { handleResponse } from "../../../utilities/handleResponse";

function Card(props) {
  const { sessionInfo } = useSession();
  const { ConfirmationModal, setTitle, setMetaData, setOpenModal } =
    useConfirmationModal();

  const { company_id, context } = sessionInfo;
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showActivityDropdown, setShowActivityDropdown] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false); // State for schedule modal
  const [sceduleActivityList, setSceduleActivityList] = useState({
    overdue: [],
    today: [],
    planned: [],
  });

  const [showModal, setShowModal] = useState(false);

  const { id, name, partner_id, expected_revenue, priority, activity_state } =
    props.card;

  const partnerName = partner_id && partner_id.length > 1 ? partner_id[1] : "";

  const handleDragStart = (event) => {
    const cardId = props.card.id;
    const stageId = props.stageId;
    event.dataTransfer.setData("cardId", cardId);
    event.dataTransfer.setData("stageId", stageId);
    dispatch(dragStart({ stageId, cardId }));
  };

  const handleDragEnd = () => {
    dispatch(dragEnd());
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    dispatch(dragOver({ stageId: props.stageId, cardId: props.card.id }));
  };

  const handleMoreButtonClick = (event) => {
    event.stopPropagation();

    setShowActivityDropdown(false);

    setShowDropdown(!showDropdown);
  };

  const handleActivitySchedule = async (event) => {
    event.stopPropagation();
    let response = await activityFormat({
      id: props.card.activity_ids,
      company_id,
      context,
    });
    response = JSON.parse(response);
    const activities = {
      overdue: [],
      today: [],
      planned: [],
    };
    response?.result?.forEach((activity) => {
      activities?.[activity.state]?.push(activity);
    });
    setShowDropdown(false); // Close other dropdown if open

    setShowActivityDropdown(!showActivityDropdown);
    setSceduleActivityList({ ...activities });
  };

  const handleDeleteCard = async () => {
    const response = await props.removeCard(props.stageId, id);

    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage: "Lead Deleted Successfully",
    });
  };

  const handleStarClick = (event, starIndex) => {
    event.stopPropagation(); // Prevent the event from reaching the parent elements

    // Dispatch action to update card's priority

    dispatch(
      updateCard({
        stageId: props.stageId,
        cardId: id,
        updatedCard: { ...props.card, priority: starIndex + 1 },
      })
    );
    dispatch(
      updateCard({
        stageId: props.stageId,
        cardId: id,
        updatedCard: { ...props.card, priority: starIndex + 1 },
      })
    );
  };

  const renderStars = (priority) => {
    const stars = [];
    for (let i = 0; i < 3; i++) {
      stars.push(
        <Star
          key={i}
          className={`star ${i < priority ? "filled" : ""}`}
          onClick={(event) => handleStarClick(event, i)}
        />
      );
    }
    return stars;
  };

  const clockColor = useMemo(() => {
    if (activity_state === "overdue") {
      return "red";
    } else if (activity_state === "planned") {
      return "green";
    } else if (activity_state === "today") {
      return "#d39e00";
    } else {
      return "grey"; // Default color
    }
  }, [activity_state]);
  return (
    <>
      <ConfirmationModal
        handleYes={handleDeleteCard}
        handleNo={() => {
          setOpenModal(false);
        }}
      />
      {showModal && (
        <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
          <NewLeadForm />
        </Modal>
      )}
      {showScheduleModal && ( // Render ScheduleActivityModal when showScheduleModal is true
        <Modal
          isOpen={showScheduleModal}
          onClose={() => setShowScheduleModal(false)}
        >
          <SchuduleScreen
            handleCloseModal={() => setShowScheduleModal(false)}
            cardId={id}
          />
        </Modal>
      )}
      <div
        className="card"
        onMouseLeave={() => {
          setShowDropdown(false);
        }}
        draggable
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onDragOver={(event) => handleDragOver(event)}
        onClick={(e) => {
          if (showDropdown) {
            handleMoreButtonClick(e);
            return;
          }
          if (showActivityDropdown) {
            setShowActivityDropdown(false);
            return;
          }
          props.handleCreateLead({
            stageId: props.stageId,
            type: "view",
            card: props.card,
          });
        }}
      >
        <div className="card_top">
          <div className="card_title">{name}</div>
          <div className="card_top_more d-flex justify-content-end me-3">
            <MoreVertical onClick={handleMoreButtonClick} />
            {showDropdown && (
              <Dropdown
                className="board_dropdown"
                onClose={() => setShowDropdown(false)}
              >
                <p
                  onClick={() => {
                    setOpenModal(true);
                    setTitle("");
                    setMetaData({
                      primaryButton: "Yes",
                      secondaryButton: "No",
                      dangerouslySetInnerHTML: "",
                    });
                    setShowDropdown(false);
                  }}
                >
                  Delete Card
                </p>
              </Dropdown>
            )}
          </div>
        </div>
        <div className="card_description">{partnerName}</div>
        <div className="card_description">$ {expected_revenue}</div>
        <div className="card_priority">
          {renderStars(priority)}
          <div className="kanban_state">
            {/* <FaRegClock
              style={{ color: clockColor, fontWeight: "bold" }}
              onClick={handleActivitySchedule}
            /> */}
            {showActivityDropdown && (
              <Dropdown
                dropdownContentClass="px-0"
                className="dropdown_style"
                onClose={() => setShowActivityDropdown(false)}
              >
                <div
                  className="content"
                  style={{ maxHeight: 200, overflow: "auto", paddingBottom: 5 }}
                >
                  {!activity_state && (
                    <>
                      <div className="mb-2">
                        <span className="font-11">
                          Schedule activities to help you get things done.
                        </span>
                      </div>
                      <hr />
                    </>
                  )}
                  {sceduleActivityList?.overdue?.length > 0 && (
                    <ScheduleActivitiesList
                      title="overdue"
                      sceduleActivityList={sceduleActivityList?.overdue}
                      color="#bd2130"
                      showDays
                    />
                  )}
                  {sceduleActivityList?.today?.length > 0 && (
                    <ScheduleActivitiesList
                      title="today"
                      sceduleActivityList={sceduleActivityList?.today}
                      color="#d39e00"
                    />
                  )}
                  {sceduleActivityList?.planned?.length > 0 && (
                    <ScheduleActivitiesList
                      title="planned"
                      sceduleActivityList={sceduleActivityList?.planned}
                      color="#1e7e34"
                      showDays
                    />
                  )}
                  <button
                    className="schedule_button font-12"
                    onClick={(event) => {
                      event.stopPropagation();
                      setShowScheduleModal(true);
                    }}
                  >
                    + Schedule an activity
                  </button>{" "}
                </div>
              </Dropdown>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
